import { Switch, styled as MUIStyled } from "@mui/material";
import styled from "styled-components";

const MapContainer = styled.div`
  height: 600px;
  width: 600px;
`;

const EmptyMapMessage = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 600px;
  max-width: 100%;
  padding: 24px;
  box-sizing: border-box;
  color: #616161;
`;

const DialogActions = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  button {
    color: #9400ee;
  }
`;

export const PurpleSwitch = MUIStyled(Switch)(() => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#6200EE"
  },

  "& .MuiSwitch-track": {
    backgroundColor: "#AAA"
  },

  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#6200EE"
  }
}));

export default { MapContainer, EmptyMapMessage, DialogActions };